<div class="container">
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <div class="panel panel-default">
                <div class="panel-heading">Settings</div>
                <div class="panel-body">
                    <div class="col-md-12">
                        <label for="email" class="col-md-4 control-label">Odds Provider</label>
                        <div class="col-md-6">
                            <select class="form-control" id="oddsProvider">
                                <!-- <option [selected]="oddsProvider == 'diamond'" value='diamond'>Diamond</option> -->
                                <option [selected]="oddsProvider == 'neeraj'" value='neeraj'>Neeraj</option>
                                <!-- <option [selected]="oddsProvider == 'sky'" value='sky'>Sky</option> -->
                            </select>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="col-md-12">
                        <label for="email" class="col-md-4 control-label">Fancy Provider</label>
                        <div class="col-md-6">
                            <select class="form-control" id="fancyProvider">
                                <!-- <option [selected]="fancyProvider == 'diamond'" value='diamond'>Diamond</option>
                                <option [selected]="fancyProvider == 'neeraj'" value='neeraj'>Neeraj</option> -->
                                <option [selected]="fancyProvider == 'sk'" value='sk'>Sky</option>
                            </select>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="col-md-12 col-xs-4">
                        <div class="col-md-1 col-md-offset-4">
                            <button [disabled]="isSubmitted" type="button" (click)="onProviderChange()"
                                class="btn btn-primary">
                                <i class="fa fa-btn fa-sign-in"></i> Save
                            </button>
                        </div>
                        <div class="col-md-2">
                            <div *ngIf="isLoading" class="row center" style="margin-top: 3px;">
                                <div class="spinner-border text-danger" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-8 col-md-offset-2">
            <div class="panel panel-default">
                <div class="panel-heading">Set Message</div>
                <div class="panel-body">
                    <div class="col-md-12">
                        <label for="email" class="col-md-4 control-label">Message</label>
                        <div class="col-md-8">
                            <textarea id="message" rows="6" class="form-control" placeholder="Enter Message"></textarea>
                        </div>
                    </div>
                    <div class="col-md-12 col-xs-4" style="margin-top:20px;">
                        <div class="col-md-1 col-md-offset-4">
                            <button [disabled]="isSubmittedM" type="button" (click)="setMessage()"
                                class="btn btn-primary">
                                <i class="fa fa-btn fa-sign-in"></i> Submit
                            </button>
                        </div>
                        <div class="col-md-2">
                            <div *ngIf="isLoadingM" class="row center" style="margin-top: 3px;">
                                <div class="spinner-border text-danger" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>